import { render, staticRenderFns } from "./btn-text-secondary.vue?vue&type=template&id=cd1723f6&scoped=true"
import script from "./btn-text-secondary.vue?vue&type=script&lang=js"
export * from "./btn-text-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1723f6",
  null
  
)

export default component.exports